import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        isScrolled ? 'shadow-sm' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo - Larger */}
          <a href="/" className="flex items-center">
            <img
              src={siteConfig.logo}
              alt="SuperHunt"
              className="h-14 sm:h-[72px] w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {/* Nav Links */}
            <button
              onClick={() => scrollToSection('product')}
              className="text-[var(--text-secondary)] hover:text-[var(--brand-teal-600)] font-medium transition-colors"
            >
              Product
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-[var(--text-secondary)] hover:text-[var(--brand-teal-600)] font-medium transition-colors"
            >
              FAQs
            </button>
            <button
              onClick={() => scrollToSection('team')}
              className="text-[var(--text-secondary)] hover:text-[var(--brand-teal-600)] font-medium transition-colors"
            >
              Team
            </button>
            
            {/* Divider */}
            <div className="w-px h-6 bg-gray-200" />
            
            {/* Action Buttons */}
            <a
              href={siteConfig.appLoginUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--text-secondary)] hover:text-[var(--brand-teal-600)] font-medium transition-colors"
            >
              Login / Request Invite
            </a>
            <a
              href={siteConfig.calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Schedule Demo
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col gap-2">
              <button
                onClick={() => scrollToSection('product')}
                className="w-full text-left px-4 py-3 text-[var(--text-secondary)] hover:bg-gray-50 rounded-lg font-medium transition-colors"
              >
                Product
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="w-full text-left px-4 py-3 text-[var(--text-secondary)] hover:bg-gray-50 rounded-lg font-medium transition-colors"
              >
                FAQs
              </button>
              <button
                onClick={() => scrollToSection('team')}
                className="w-full text-left px-4 py-3 text-[var(--text-secondary)] hover:bg-gray-50 rounded-lg font-medium transition-colors"
              >
                Team
              </button>
              <div className="border-t border-gray-100 my-2" />
              <a
                href={siteConfig.appLoginUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center px-4 py-3 text-[var(--text-secondary)] hover:bg-gray-50 rounded-lg font-medium transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Login / Request Invite
              </a>
              <a
                href={siteConfig.calendlyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary w-full text-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Schedule Demo
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
